import { Navigate, Route, Routes } from 'react-router-dom';

import AdminAuthGuard from './components/AdminAuthGuard';
import AdminLayout from './components/AdminLayout';
import AttorneysManager from './pages/AttorneysManager';
import CareersManager from './pages/CareersManager';
import CompanyInfoManager from './pages/CompanyInfoManager';
import Dashboard from './pages/Dashboard';
import DatabaseManager from './pages/DatabaseManager';
import HomepageManager from './pages/HomepageManager';
import ImageManager from './pages/ImageManager';
import PracticeAreasManager from './pages/PracticeAreasManager';
import PublicationsManager from './pages/PublicationsManager';
import React from 'react';
import SystemHealthMonitor from './pages/SystemHealthMonitor';

const AdminRoutes = () => {
	return (
		<AdminAuthGuard>
			<AdminLayout>
				<Routes>
					<Route path='/' element={<Dashboard />} />
					<Route path='/attorneys' element={<AttorneysManager />} />
					<Route path='/careers' element={<CareersManager />} />
					<Route path='/images' element={<ImageManager />} />
					<Route path='/homepage' element={<HomepageManager />} />
					<Route path='/practice-areas' element={<PracticeAreasManager />} />
					<Route path='/publications' element={<PublicationsManager />} />
					<Route path='/company-info' element={<CompanyInfoManager />} />
					<Route path='/database' element={<DatabaseManager />} />
					<Route path='/system' element={<SystemHealthMonitor />} />
					<Route path='*' element={<Navigate to='/admin' replace />} />
				</Routes>
			</AdminLayout>
		</AdminAuthGuard>
	);
};

export default AdminRoutes;
